
//prints the eReport based on the occurrence id passed in
//uses hard coded area path as could be called from many different areas
function printEreport(id) {
  var frid = $(document.getElementById('qform.id'));
  id = frid.val();
  if (id.length > 0) {
    var url = $.buildUrl("/eReport.aspx/eReport/EreportPrintCriteria", { eReportNo: id });
    $.portalDialog(url, $.buildUrl("/eReport.aspx/eReport/PrintButtons"), "{477C0E29-259D-4D16-A848-6F4327DD7039}", "{BD3A9220-6655-47da-B822-5045DF1BF197}", function () { }, 670);    
  }   
}

